import { navigateTo } from '../common/frontend/route-utils.js'
import { t } from '../common/i18n.js'
import { balancetimeModel } from './models/balancetime.js'
import { eatModel } from './models/eat.js'
import { leaderboardModel } from './models/leaderboard.js'
import { playtimeModel } from './models/playtime.js'
import { portalModel } from './models/portal.js'
import { signatureToolModel } from './models/signaturetool.js'
import { urlShortenerModel } from './models/url-shortener.js'
import { worktimeModel } from './models/worktime.js'
import { MenuItem, View } from './types.js'

export const getMenuItems = (hasActiveCampaign: boolean): MenuItem[] => {
    const items: MenuItem[] = [
        portalModel.menuItem,
        playtimeModel.menuItem,
        eatModel.menuItem,
        worktimeModel.menuItem,
        balancetimeModel.menuItem,
        leaderboardModel.menuItem,
        {
            text: t.common.shell.infoMenu,
            url: '#',
            href: 'https://sites.google.com/play.ee/space',
            matchingRoutes: [],
        },
        signatureToolModel.menuItem,
        urlShortenerModel.menuItem,
    ]

    if (hasActiveCampaign) {
        items.push({
            text: () => 'Q12',
            url: '#',
            isButton: true,
            matchingRoutes: [],
            onClick: (view: View) => {
                void (async () => {
                    try {
                        const res = await view.api.playtime.getUnansweredCampaign()
                        if (res.data) {
                            navigateTo(`/survey/${res.data.id}`)
                        }
                    } catch {
                        // No campaign available
                    }
                })()
            },
        })
    }

    return items
}
